import api from './api';

const ValidateCard = {
    check: (card_proxy, cpf) => api.post('validate-card', { card_proxy, cpf }),
};

export default ValidateCard;